import { Component, Input, isDevMode, OnInit } from '@angular/core';

import { Router } from '@angular/router';
import { NbAuthJWTToken, NbAuthService } from '@nebular/auth';
import { NbMenuService, NbSidebarService } from '@nebular/theme';
import { UserService } from '../../../@core/data/users.service';
import { AnalyticsService } from '../../../@core/utils/analytics.service';
import { ISftpFileCount, SftpDataCryptoService } from '../../../pages-crypto/service-crypto/sftp-data-crypto.service';
import { environment } from '../../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { IProvider } from '../../../pages-crypto/components-crypto/provider-report-crypto/provider-report-crypto.component';

@Component({
  selector: 'ngx-header',
  // providers: [ SftpDataCryptoService ], // takto nefunguje :(
  styleUrls: [ './header.component.scss' ],
  templateUrl: './header.component.html',
})
export class HeaderComponent implements OnInit {

  @Input() position = 'normal';

  user: any;

  // https://github.com/akveo/nebular/issues/11
  // https://github.com/akveo/nebular/issues/314
  userMenu = [ { title: 'Profile', link: '/pages/profile' }, { title: 'Log out', link: '/auth/logout' } ];
  sftpData: ISftpFileCount[];
  totalCount: number = 0;

  constructor(private httpClient: HttpClient,
              private sidebarService: NbSidebarService,
              private menuService: NbMenuService,
              private userService: UserService,
              private analyticsService: AnalyticsService,
              private authService: NbAuthService,
              private sftpDataCryptoService: SftpDataCryptoService,
              private router: Router) {

    // https://akveo.github.io/nebular/docs/auth/getting-user-token#related-articles
    this.authService.onTokenChange()
      .subscribe((token: NbAuthJWTToken) => {
        if (token.isValid()) {
          if (isDevMode()) {
            console.log('[HeaderComponent] token=' + JSON.stringify(token.getPayload()));
          }
          this.user = { name: token.getPayload().user_name, picture: 'assets/images/user.png' };
        }
      });
  }

  ngOnInit() {
    if (isDevMode()) {
      console.log('HeaderComponent sftpData.subscribe called...');
    }
    // Get initial count of SFTP files...
    this.httpClient.get<any>(environment.service_provider,
    ).subscribe( // Observables needs to be observer in order to execute GET/POST
      (response: IProvider[]) => {
        for (const iProvider of response) {
          this.totalCount += iProvider.lastCount;
        }
        if (isDevMode()) {
          console.log('Total count of SFTP files=' + this.totalCount);
        }
      },
      (error) => {
        console.log('Error retrieving total count of SFTP files.' + error);
      });
    // this.userService.getUsers()
    //   .subscribe((users: any) => this.user = users.nick);
    this.sftpDataCryptoService.sftpData.subscribe((data: ISftpFileCount[]) => {
      if (isDevMode()) {
        console.log('Data=' + data);
      }
      this.sftpData = data;
      this.totalCount = 0;
      for (const sftpData of data) {
        this.totalCount += sftpData.count;
      }
    })
  }

  toggleSidebar(): boolean {
    this.sidebarService.toggle(true, 'menu-sidebar');
    return false;
  }

  toggleSettings(): boolean {
    this.sidebarService.toggle(false, 'settings-sidebar');
    return false;
  }

  goToHome() {
    this.menuService.navigateHome();
  }

  startSearch() {
    this.analyticsService.trackEvent('startSearch');
  }

  showSftpStatus() {
    this.router.navigate([ 'pages/ftp-status' ]);
  }
}



// WEBPACK FOOTER //
// ./src/app/@theme/components/header/header.component.ts